/* Suri sizing drawer: native modal focus containment, accessible tabs, no cart writes. */
if (!customElements.get('suri-size-guide')) {
  customElements.define('suri-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.onOpen = (event) => {
        const trigger = event.target.closest('[data-suri-guide-open]');
        if (!trigger || trigger.dataset.suriGuideOpen !== this.dialog.id) return;
        this.opener = trigger;
        this.setCategory(this.dataset.defaultCategory);
        this.setTab('measure');
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.querySelector('[data-sg-close]').focus();
      };
      this.onClick = (event) => {
        if (event.target.closest('[data-sg-close]')) this.dialog.close();
        const tab = event.target.closest('[data-sg-tab]');
        if (tab) this.setTab(tab.dataset.sgTab);
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.onKey = (event) => {
        if (!event.target.matches('[data-sg-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const name = event.key === 'Home' ? 'measure' : event.key === 'End' ? 'chart' : event.target.dataset.sgTab === 'measure' ? 'chart' : 'measure';
        this.setTab(name);
        this.querySelector(`[data-sg-tab="${name}"]`).focus();
      };
      this.onClose = () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        if (this.opener?.isConnected) this.opener.focus();
      };
      document.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('keydown', this.onKey);
      this.dialog.addEventListener('close', this.onClose);
      this.setCategory(this.dataset.defaultCategory);
      document.querySelectorAll('[data-suri-guide-open]').forEach(button => {
        if (button.dataset.suriGuideOpen === this.dialog.id) button.hidden = false;
      });
    }
    setCategory(category) {
      this.querySelectorAll('[data-sg-content]').forEach(panel => { panel.hidden = panel.dataset.sgContent !== category; });
      const product = this.querySelector('[data-sg-product-category]');
      product.hidden = product.dataset.sgProductCategory !== category;
      this.querySelector('.suri-sg__header h2').textContent = `${category === 'earrings' ? 'Earring' : category.slice(0, -1).replace(/^./, char => char.toUpperCase())} size guide`;
    }
    setTab(name) {
      this.querySelectorAll('[data-sg-tab]').forEach(tab => {
        const selected = tab.dataset.sgTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.querySelectorAll('[data-sg-panel]').forEach(panel => { panel.hidden = panel.dataset.sgPanel !== name; });
      this.querySelector('.suri-sg__body').scrollTop = 0;
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOpen);
      this.dialog.removeEventListener('click', this.onClick);
      this.dialog.removeEventListener('keydown', this.onKey);
      this.dialog.removeEventListener('close', this.onClose);
      if (this.dialog.open) this.onClose();
    }
  });
}
